import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_NORMAL
} from '../genericComponents/buttons/RectangleActionButton'
import iconQRCode from '../genericComponents/assets/qrcode-icon.svg'
import React from 'react'
import useModal from '../ui/useModal'
import { MODAL_IDS } from '../../store/ui/ui.constants'
import useErrorBoundaryCallback from '../utils/useErrorBoundaryCallback'
import { TAG_BLOCK_AUTOPROMO } from '../../store/analytics/analytics.actionTypes'
import analyticsConstants from '../analytics/analytics.constants'
import { withFrenchSite } from '../i18n/i18nSite'
import AutoPromoPopinGE from './AutoPromoPopinGE'

const AutoPromoOpenButton = ({ size = SIZE_NORMAL, area }) => {
  const { displayModal } = useModal(MODAL_IDS.AUTO_PROMO_POPIN)

  const onButtonClick = useErrorBoundaryCallback(displayModal)

  return (
    <>
      <RectangleActionButton
        iconUrl={iconQRCode}
        color={COLOR_GREY_EMPTY}
        label="Installer l'App"
        size={size}
        onClick={onButtonClick}
        tagData={{
          type: TAG_BLOCK_AUTOPROMO,
          tagInfo: {
            appstore: analyticsConstants.autopromo.stores.qrcode,
            area
          }
        }}
      />
      <AutoPromoPopinGE />
    </>
  )
}

export default withFrenchSite(AutoPromoOpenButton)
